import RegisterWizardContainer from "../../../../Component/OtherPages/Authentication/RegisterWizard/RegisterWizard"

const RegisterWizard = () => {
  return (
    <div className='page-body'>
      <RegisterWizardContainer />
    </div>
  )
}

export default RegisterWizard